/*
 * This contains all the text shape options
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  rectangular: {
    id: 'cwt.translations.rectangular',
    defaultMessage: 'Rectangular',
  },
  'l-shape': {
    id: 'cwt.translations.l-shape',
    defaultMessage: 'L-shape',
  },
  'u-shape': {
    id: 'cwt.translations.u-shape',
    defaultMessage: 'U-shape',
  },
  'v-shape': {
    id: 'cwt.translations.v-shape',
    defaultMessage: 'V-shape',
  },
  'c-shape': {
    id: 'cwt.translations.c-shape',
    defaultMessage: 'C-shape',
  },
  'ii-shape': {
    id: 'cwt.translations.ii-shape',
    defaultMessage: 'II-shape',
  },
  irregular: {
    id: 'cwt.translations.irregular',
    defaultMessage: 'Irregular',
  }, 
  'g-shape':{
    id: 'cwt.translations.g-shape',
    defaultMessage: 'G-shape'
  }
});
